import * as APITypes from "~/API";

export const refreshFinanceData = async (
  year: number,
  month: number,
  day: number,
  entityType: APITypes.EntityType | "user",
  entityID: string,
  closeReport: boolean
) => {
  try {
    const response = await fetch(
      `http://34.138.174.37/api/v1/finance/report/${year}/${month}/${day}/${entityType}/${entityID}/${closeReport}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
    const data = response.json();
    return {
      success: true,
      data: data,
    };
  } catch (error) {
    return {
      success: false,
      data: {},
      error,
    };
  }
};
